import React from 'react';
import { Button } from 'react-native';

const containerStyle = {
	display: 'flex',
	flexWrap: 'wrap',
	gap: 12,
	justifyContent: 'center',
	margin: '16px 0 24px',
};

const actionStyle = {
	flex: '1 1 calc(50% - 6px)',
	maxWidth: 'calc(50% - 6px)',
	minWidth: 220,
};

const linkStyle = {
	alignItems: 'center',
	backgroundColor: '#20a0ff',
	boxSizing: 'border-box',
	color: '#ffffff',
	display: 'flex',
	fontFamily: 'inherit',
	fontSize: 14,
	fontWeight: 600,
	justifyContent: 'center',
	minHeight: 36,
	padding: '0 12px',
	textAlign: 'center',
	textDecoration: 'none',
	width: '100%',
};

export default function TransactionActionButtons({ actions }) {
	if (!actions || actions.length === 0) {
		return null;
	}

	return (
		<div style={containerStyle}>
			{actions.map(action => action.href ?
				<div key={action.label} style={actionStyle}>
					<a href={action.href} target="_blank" rel="noopener noreferrer" style={linkStyle}
						onClick={action.onClick ? event => { event.preventDefault(); action.onClick(); } : undefined}>
						{action.label}
					</a>
				</div> :
				<div key={action.label} style={actionStyle}>
					<Button
						color="#20a0ff"
						title={action.label}
						onPress={action.onClick}
					/>
				</div>)}
		</div>
	);
}
